import React, { Component } from "react";
import { Box } from "@mui/material";

import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import EqualizerOutlinedIcon from "@mui/icons-material/EqualizerOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";

import DashboardHeader from "./DashboardHeader";
import SummaryCard from "../../components/dashlibs/SummaryCard";
import SectionCard from "../../components/dashlibs/SectionCard";
import StatusBadge from "../../components/dashlibs/StatusBadge";
import AlertList from "../../components/dashlibs/AlertList";
import { MockBarChart, MockTrendChart } from "../../components/dashlibs/MockChart";
import { DashboardFilterOptions, DashboardPageProps, DashboardSharedFilters } from "./dashboard.types";

import type { ChartTone } from "../../components/charts";
import { DonutChart, AreaTrendChart, BarChart, TreemapChart, BulletChart } from "../../components/charts";


//export default function ExecutiveDashboard(userData:any,sharedFilters:DashboardSharedFilters, filterOptions: DashboardFilterOptions, onFilterChange:Function, onRefresh:Function) {
//export default function ExecutiveDashboard(DashboardPageProps)
export default class ExecutiveDashboard extends Component<DashboardPageProps,any> {
  //const { period,cycle} = sharedFilters;
render(){
  const { userData,dashData,sharedFilters,filterOptions,onFilterChange,onRefresh} = this.props;
  const { meta,sections={},summaryCards={} } = dashData || {};

  const { budgetVsActual={},costCenters={},kpiPerformance={} } = sections;
  const { activityProgress={},criticalActivities={},productLocation={} } = sections;

  const iconMap: any = {
    wallet: <AccountBalanceWalletOutlinedIcon />,
    equalizer: <EqualizerOutlinedIcon />,
    target: <TrackChangesOutlinedIcon />,
    insights: <InsightsOutlinedIcon />,
    warning: <WarningAmberOutlinedIcon />,
  };

  // * AreaTrendChart for budget vs actual trend
  // * DonutChartCard for scenario / composition
  // * TreemapChart for KPI health
  // * AlertList for critical activities


  return (
    <Box sx={{ p: { xs: 2, md: 3 }, display: "grid", gap: 2.5 }}>
      <DashboardHeader
        title="Dashboard exécutif"
        userData={userData}
        sharedFilters={sharedFilters}
        filterOptions={filterOptions}
        onFilterChange={onFilterChange}
        onRefresh={onRefresh}
        // subtitle="Vue consolidée des budgets, de l’exécution, des performances et des alertes."
        // period="S1 2025"
        // scenario="Révisé"
        // costcenter="Tous"
        // location="Tous"
      />

      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            lg: "repeat(5, 1fr)",
          },
        }}
      >
        {(summaryCards || []).map((card: any) => (
        <SummaryCard
          key={card.code}
          title={card.label}
          value={card.valueFormatted}
          subtitle={card.subtitle}
          delta={card.deltaFormatted}
          tone={card.tone}
          icon={iconMap[card.icon] || <InsightsOutlinedIcon />}
        />
        ))}
        
      </Box>

      <Box sx={{display: "grid",gap: 2,gridTemplateColumns: { xs: "1fr", lg: "1.35fr 1fr" }}}>
        <SectionCard
          title={budgetVsActual.title || "Budget vs Réalisations"}
          subtitle={budgetVsActual.subtitle || "Comparaison synthétique des principaux postes sur la période sélectionnée."}
          action={<StatusBadge label={budgetVsActual.badge || "Révisé "} tone="info" />}
        >
          <AreaTrendChart data={budgetVsActual.data || []} />
        </SectionCard>

        <SectionCard
          title={costCenters.title || "Centres de coûts"}
          subtitle={costCenters.subtitle || "Niveau d’exécution des principaux centres."}
        >
          <BarChart horizontal data={(costCenters.data || []).map((x: any) => ({
              label: x.label,
              value: Number(x.value || 0),
              color: "#163A5F",
            }))}
          />
        </SectionCard>
      </Box>

      <Box sx={{display:"grid", gap:2, gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" }}} >
        <SectionCard
          title={kpiPerformance.title || "KPI par axe"}
          subtitle={kpiPerformance.subtitle || "Progression des axes stratégiques sur la période."}
        >
          {/* <Box sx={{ maxHeight: 280, overflowY: "auto", pr: 0.5 }}>
          <MockBarChart
            data={(kpiPerformance.data || []).map((x: any) => ({
              label: x.label,
              value: Number(x.actual || 0),
              color:
                x.trafficlight === "GREEN"
                  ? "#116B43"
                  : x.trafficlight === "AMBER"
                  ? "#D68910"
                  : "#B42318",
            }))}
          />
          </Box> */}
          <TreemapChart data={kpiPerformance.data || []}/>
        </SectionCard>

        <SectionCard
          title={activityProgress.title || ""}
          subtitle={activityProgress.subtitle || ""}
        >
          <Box sx={{ maxHeight: 280, overflowY: "auto", pr: 0.5 }}>
            <BulletChart data={activityProgress.data || []} />
          </Box>
        </SectionCard>
      </Box>

      <Box sx={{display:"grid", gap:2, gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" }}} >
        <SectionCard
          title={criticalActivities.title || "Activités critiques"}
          subtitle={criticalActivities.subtitle || "Activités nécessitant un suivi renforcé."}
        >
          <Box sx={{ maxHeight: 280, overflowY: "auto", pr: 0.5 }}>
            <AlertList items={criticalActivities.data || []} />
          </Box>
        </SectionCard>

        <SectionCard
          title={productLocation.title || "Produits / Dépôts"}
          subtitle={productLocation.subtitle || "Vue simplifiée par produit et localisation."}
        >
          <BarChart data={(productLocation.data || [])}
          />
        </SectionCard>
      </Box>
    </Box>
  );
}
}
